import { render, staticRenderFns } from "./dispatch.vue?vue&type=template&id=759ca520&scoped=true&"
import script from "./dispatch.vue?vue&type=script&lang=js&"
export * from "./dispatch.vue?vue&type=script&lang=js&"
import style0 from "./dispatch.vue?vue&type=style&index=0&id=759ca520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759ca520",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VFlex,VLayout})
